import {ApiClient as Api} from '@hconnect/apiclient'
import {useNotification} from '@hconnect/uikit'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useEffect} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {KpiTabValuesDto, SlaTrackingQueryKey, TabTypeDto} from '../../types'

type Params = {
  plantUpmId: string
  year: number
  tabType?: TabTypeDto
}

export const useSlaKpiTabValues = (
  {plantUpmId, year, tabType}: Params,
  options?: Omit<UseQueryOptions<KpiTabValuesDto[], AxiosError>, 'queryKey' | 'queryFn'>
) => {
  const {notify} = useNotification()
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const params = {year}
  const queryKey = tabType
    ? [SlaTrackingQueryKey.SlaKpiTabValues, plantUpmId, year, tabType]
    : [SlaTrackingQueryKey.SlaKpiTabValues, plantUpmId, year]

  const query = useQuery<KpiTabValuesDto[], AxiosError>({
    queryKey: queryKey,
    queryFn: async ({signal}) => {
      const basePath = `/sla-kpi-tracking/api/${plantUpmId}/sla-kpi/tab-values`
      const path = tabType ? `${basePath}/${tabType}` : basePath

      const response = await Api.axiosInstance.get(path, {params, signal})
      return tabType ? [response.data] : response.data
    },
    ...options
  })

  useEffect(() => {
    if (query.error) {
      notify('error', t('message.failedToFetch'))
    }
  }, [query.error, notify, t])

  return query
}
